export const coreStoreModules = [];
